import dayjs from "dayjs";
import { TagTopic, Topic } from "shared/types";

export const getFormatTopicDate = (topic: Topic | TagTopic) => {
  const publishedAt = dayjs(topic.publishedAt);
  const lastmod = "lastmod" in topic ? dayjs(topic.lastmod) : null;

  return {
    publishedAt: publishedAt.isValid()
      ? publishedAt.format("YYYY-MM-DD")
      : null,
    publishedAtISO: publishedAt.isValid() ? publishedAt.toISOString() : null,
    lastmod: lastmod?.isValid() ? lastmod.format("YYYY-MM-DD") : null,
    lastmodISO: lastmod?.isValid() ? lastmod.toISOString() : null,
  };
};
